import { render, staticRenderFns } from "./CndTrabalhistaView.vue?vue&type=template&id=4e002d60&"
import script from "./CndTrabalhistaView.vue?vue&type=script&lang=js&"
export * from "./CndTrabalhistaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports